module.exports = __webpack_public_path__ + "static/media/plaza_felujitas_1.a8d512ab.jpg";